import data from "../assets/agenda.json";

function Agenda() {
  return (
    <header id="agenda">
      <div className="news">
        <div className="content_container responsive_width">
          <div className="news__container">
            <div className="news__row">
              <div className="center">
                <div className="agenda__container">
                  <div>
                    <h3 className="news_header header_title responsive_width">
                      Agenda
                    </h3>
                    {/* <div className="news_text header_text responsive_width">
                      Hier vind je alles wat er op het programma staat!
                    </div> */}
                  </div>
                  {data.map((data) => (
                    <AgendaCard
                      key={data.key}
                      day={data.dag}
                      month={data.maand}
                      time={data.tijd}
                      title={data.titel}
                      summary={data.omschrijving}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

function AgendaCard({ day, month, time, title, summary }) {
  return (
    <>
      <div className="agenda__card">
        <div className="agenda_card_date_field">
          <div className="agenda_card_date_number">{day}</div>
          <div className="agenda_card_date_month">{month}</div>
          <div className="agenda_card_date_month">{time}</div>
        </div>
        <div className="agenda_card_text_field">
          <div className="agenda_card_text_title">{title}</div>
          <div className="agenda_card_text_details">{summary}</div>
        </div>
      </div>
    </>
  );
}

export default Agenda;
